<div class="password-requirements mt-2">
  <div><p>Debe contener:</p></div>
  <div class="password-requiered">
    <div>
      <ng-container *ngFor="let req of passwordRequirements.slice(0, 2)">
        <p><img [src]="req.icon" alt="" /> {{ req.label }}</p>
      </ng-container>
    </div>
    <div>
      <ng-container *ngFor="let req of passwordRequirements.slice(2, 4)">
        <p><img [src]="req.icon" alt="" /> {{ req.label }}</p>
      </ng-container>
    </div>
    <div>
      <p><img [src]="passwordRequirements[4].icon" alt="" /> {{ passwordRequirements[4].label }}</p>
    </div>
  </div>
</div>
